.ds-social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 2px;
  background-color: var(--footer-background-icon);

  &__icon {
    --ds-icon-width: #{rem(1)};
    --ds-icon-height: #{rem(1)};
    fill: var(--footer-icon-color);
  }
}
